import type { ClientMessage } from '../../shared/protocol';
import type { SnapshotState } from './room-session-state';

/**
 * The message that starts the current Endless board's clock, or null when a touch changes
 * nothing: the clock already runs, the round is not in play, or this player cannot play it.
 * The server ignores a repeat, so a touch before the clock's snapshot arrives is harmless.
 */
export function boardActivityMessage(
  snapshot: Pick<SnapshotState, 'phase' | 'roundId' | 'finished' | 'spectator' | 'endlessBoard'>,
): Extract<ClientMessage, { t: 'boardActive' }> | null {
  const board = snapshot.endlessBoard;
  if (!board || board.endAt > 0 || snapshot.phase !== 'playing' || !snapshot.roundId) return null;
  if (snapshot.finished || snapshot.spectator) return null;
  return { t: 'boardActive', roundId: snapshot.roundId, board: board.number };
}
